export async function consumeSseStream(reader, onEvent) {
    const decoder = new TextDecoder()
    let buffer = ''

    while (true) {
        const { value, done } = await reader.read()
        if (done) break

        buffer += decoder.decode(value, { stream: true })

        const parts = buffer.split('\n\n')
        buffer = parts.pop() || ''

        for (const part of parts) {
            if (!part.trim()) continue

            let event = 'message'
            let data = ''

            for (const line of part.split('\n')) {
                if (line.startsWith('event: ')) {
                    event = line.slice(7).trim()
                } else if (line.startsWith('data: ')) {
                    data += line.slice(6)
                }
            }

            if (!data) continue

            let parsed = data
            try {
                parsed = JSON.parse(data)
            } catch {
                // keep raw string
            }

            onEvent(event, parsed)
        }
    }
}

export async function parseErrorResponse(res) {
    const errorText = await res.text()
    if (!errorText) return 'Network error'

    try {
        const parsed = JSON.parse(errorText)
        return parsed.error || parsed.message || errorText
    } catch {
        return errorText
    }
}
